import React from 'react';

const TimeIcon = ({ size = 20, color = 'black' }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={size}
		height={size}
		viewBox='0 0 20 20'
		fill='none'>
		<path
			opacity='0.4'
			d='M19.9998 10C19.9998 15.524 15.5228 20 9.99976 20C4.47676 20 -0.000244141 15.524 -0.000244141 10C-0.000244141 4.47802 4.47676 1.52588e-05 9.99976 1.52588e-05C15.5228 1.52588e-05 19.9998 4.47802 19.9998 10Z'
			fill={color}
		/>
		<path
			d='M13.5734 13.8145C13.4424 13.8145 13.3104 13.7805 13.1894 13.7095L9.26344 11.3675C9.03744 11.2315 8.89844 10.9865 8.89844 10.7225V5.67552C8.89844 5.26152 9.23444 4.92552 9.64844 4.92552C10.0624 4.92552 10.3984 5.26152 10.3984 5.67552V10.2965L13.9584 12.4195C14.3134 12.6325 14.4304 13.0925 14.2184 13.4485C14.0774 13.6835 13.8284 13.8145 13.5734 13.8145Z'
			fill={color}
		/>
	</svg>
);

export default TimeIcon;
